import React from "react"
import { styled } from "@mui/material/styles"
import LoginIcon from "assets/images/BusinessDLogin.png"
import ImageButton from "atoms/button/ImageButton"

import { DLogin } from "apis/DLogin"

const StyledImg = styled("img")({
  width: "170px",
})

const DLoginButton = (props) => {
  return (
    <ImageButton
      disableRipple
      onClick={() => {
        DLogin({ fromButton: true })
      }}
      id="dLoginButton"
    >
      <StyledImg src={LoginIcon} alt="d ログイン" />
    </ImageButton>
  )
}

export default DLoginButton
